// ConfigurationManager.js - VERSION COMPLÈTE AVEC SYNC SERVEUR
import axios from 'axios';

class ConfigurationManager {
  constructor() {
    this.currentLocationId = localStorage.getItem('activeLocationId') || 'default';
    this.config = this.getDefaultConfig();
    this.loadFromStorage();
    console.log(`⚙️ ConfigurationManager initialisé (Localisation: ${this.currentLocationId})`);
  }

  getDefaultConfig() {
    return {
      restaurant: {
        name: "SPINTOSS",
        type: "restaurant",
        hasTables: true,
        hasDelivery: true,
        hasTakeAway: true,
        defaultTableMode: "dineIn",
        locations: [
          {
            id: "jm",
            name: "SPINTOSS JM",
            address: "JARDINS D'EL MENZAH 2",
            type: "restaurant",
            hasTables: true
          },
          {
            id: "tm",
            name: "SPINTOSS TM",
            address: "TUNISIA MALL",
            type: "foodtrack",
            hasTables: false
          }
        ],
        openingHours: {
          monday: { open: "08:00", close: "23:00" },
          tuesday: { open: "08:00", close: "23:00" },
          wednesday: { open: "08:00", close: "23:00" },
          thursday: { open: "08:00", close: "00:00" },
          friday: { open: "08:00", close: "00:00" },
          saturday: { open: "08:00", close: "00:00" },
          sunday: { open: "08:00", close: "23:00" }
        }
      },
      features: {
        tableSystem: {
          enabled: true,
          autoGenerateBillNumber: true,
          maxTables: 200, // CHANGÉ À 200
          allowTableTransfer: true,
          allowTableLock: true,
          showTableStatus: true
        },
        payment: {
          enabled: true,
          methods: ["Espece", "TPE", "T.Resto", "Glovo", "Yassir"],
          requirePaymentMethod: true,
          allowPartialPayment: true,
          allowSplitBill: false,
          printReceipt: true,
          autoPrint: true
        },
        staff: {
          enabled: true,
          discountPercentage: 20,
          requireStaffSelection: true,
          logStaffSales: true
        },
        cancellation: {
          enabled: true,
          requireAdminCode: true,
          adminCodes: ["58587717", "98315003", "56332244"],
          allowStockRestoration: true,
          requireCancellationReason: true
        },
        menu: {
          showCategories: true,
          showSubProducts: true,
          showPrices: true,
          showStock: false,
          allowQuantityModification: true,
          quickAddButtons: true
        }
      },
      ui: {
        visibleSections: {
          tablesSection: true,
          categoriesSection: true,
          productsSection: true,
          additionSection: true,
          paymentSection: true,
          staffSection: true,
          cancelSection: true,
          discountSection: true,
          historySection: false
        },
        visibleElements: {
          tableNumberInput: true,
          tableSelectionPopup: true,
          pendingTablesButton: true,
          lockTableButton: true,
          transferTableButton: true,
          partialPaymentButton: true,
          staffDiscountButton: true,
          printAdditionButton: true,
          cancelArticleButton: true
        },
        customization: {
          theme: "default",
          primaryColor: "#4CAF50",
          secondaryColor: "#2196F3",
          fontSize: "medium",
          language: "fr"
        }
      },
      promotions: {
        settings: {
          enablePromotions: true,
          autoApply: true,
          maxDiscount: 70,
          allowCumulative: false,
          priority: ["datePromotions", "happyHours", "permanentPromotions"],
          showInAddition: true
        },
        happyHours: [
          {
            id: "hh1",
            name: "Happy Hour Matin",
            days: [0, 1, 2, 3, 4, 5, 6],
            startTime: "08:00",
            endTime: "10:00",
            discount: 50,
            categories: ["BEVERAGES"],
            products: [],
            isActive: true,
            showInAddition: true
          }
        ],
        datePromotions: [
          {
            id: "dp1",
            name: "Promo Weekend Pizza",
            startDate: "2024-01-01",
            endDate: "2024-12-31",
            days: [5, 6],
            discount: 25,
            categories: ["FOOD"],
            products: ["pizza", "PIZZA", "Pizza"],
            isActive: true,
            showInAddition: true
          }
        ],
        permanentPromotions: [
          {
            id: "pp1",
            name: "Menu Étudiant",
            discount: 10,
            categories: ["FOOD", "BEVERAGES"],
            products: [],
            conditions: { requireStudentCard: true },
            isActive: true,
            showInAddition: true
          }
        ],
        discountCodes: [
          {
            code: "SPINTOSS10",
            discount: 10,
            expirationDate: "2024-12-31",
            usageLimit: 100,
            usedCount: 0,
            isActive: true
          }
        ]
      },
      advanced: {
        autoActions: {
          autoRefreshTables: true,
          refreshInterval: 10000,
          autoSaveBill: true,
          autoBackup: false,
          backupInterval: 3600000
        },
        security: {
          requireLogin: true,
          sessionTimeout: 1800,
          logAllActions: true,
          encryptSensitiveData: false
        },
        performance: {
          lazyLoadProducts: true,
          cacheProducts: true,
          cacheDuration: 300000,
          limitProductDisplay: 50
        }
      }
    };
  }

  async saveToStorage() {
    try {
      const isDefault = !this.currentLocationId || this.currentLocationId === 'default';
      const storageKey = isDefault ? 'restaurantConfig' : `restaurantConfig_${this.currentLocationId}`;

      localStorage.setItem(storageKey, JSON.stringify(this.config));
      localStorage.setItem('activeLocationId', this.currentLocationId || 'default');

      console.log(`💾 Local: Sauvegardé pour [${this.currentLocationId || 'default'}]`);

      // 🔥 SYNC SERVEUR : Pousser vers la DB si ce n'est pas la config par défaut
      if (!isDefault && this.currentLocationId.length > 5) { // Éviter les IDs courts comme 'jm'
        try {
          await axios.put(`/api/Locationspin/updateConfig/${this.currentLocationId}`, {
            config: this.config
          });
          console.log(`📡 Serveur: Config synchronisée pour ${this.currentLocationId}`);
        } catch (serverError) {
          console.error("❌ Erreur sync serveur:", serverError.message);
        }
      }

      return true;
    } catch (error) {
      console.error("Erreur sauvegarde config:", error);
      return false;
    }
  }

  async loadFromStorage() {
    try {
      const isDefault = !this.currentLocationId || this.currentLocationId === 'default';
      const storageKey = isDefault ? 'restaurantConfig' : `restaurantConfig_${this.currentLocationId}`;

      // 1. D'abord charger du localStorage (pour la rapidité)
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        this.config = this.deepMerge(this.getDefaultConfig(), JSON.parse(saved));
        console.log(`📖 Local: Chargé pour [${this.currentLocationId || 'default'}]`);
      } else {
        this.config = this.getDefaultConfig();
      }

      // 2. Tenter de synchroniser avec le serveur si on a un ID valide
      if (!isDefault && this.currentLocationId.length > 5) {
        try {
          console.log(`📡 Serveur: Tentative de récupération config pour ${this.currentLocationId}...`);
          // On peut utiliser getAllLocations pour trouver celle-ci ou ajouter un endpoint GetOne
          const response = await axios.get('/api/Locationspin/getAllLocations');
          const currentLocation = response.data.find(l => l._id === this.currentLocationId);

          if (currentLocation && currentLocation.config) {
            this.config = this.deepMerge(this.getDefaultConfig(), currentLocation.config);
            // Mettre à jour le cache local
            localStorage.setItem(storageKey, JSON.stringify(this.config));
            console.log(`📡 Serveur: Config chargée et mise en cache pour ${this.currentLocationId}`);
          }
        } catch (serverError) {
          console.error("❌ Erreur chargement serveur:", serverError.message);
        }
      } else if (isDefault) {
        // Chargement config globale (déjà fait via localStorage ci-dessus, mais on s'assure du repli)
        const globalSaved = localStorage.getItem('restaurantConfig');
        if (globalSaved) {
          this.config = this.deepMerge(this.getDefaultConfig(), JSON.parse(globalSaved));
        }
      }

      return true;
    } catch (error) {
      console.error("Erreur chargement config:", error);
      return false;
    }
  }

  deepMerge(target, source) {
    const output = Object.assign({}, target);

    if (this.isObject(target) && this.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (this.isObject(source[key])) {
          if (!(key in target)) {
            Object.assign(output, { [key]: source[key] });
          } else {
            output[key] = this.deepMerge(target[key], source[key]);
          }
        } else if (Array.isArray(source[key])) {
          output[key] = source[key];
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }

    return output;
  }

  isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
  }

  // ============ MÉTHODES PUBLIQUES ============

  getConfig() {
    return JSON.parse(JSON.stringify(this.config));
  }

  updateConfig(path, value) {
    const keys = path.split('.');
    let current = this.config;

    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) {
        current[keys[i]] = {};
      }
      current = current[keys[i]];
    }

    current[keys[keys.length - 1]] = value;
    this.saveToStorage();
    return true;
  }

  // Pour la compatibilité
  init(customConfig = null) {
    if (customConfig) {
      this.config = this.deepMerge(this.config, customConfig);
      this.saveToStorage();
    }
    return this;
  }

  // Changer de localisation active
  setLocation(locationId) {
    if (this.currentLocationId !== locationId) {
      this.currentLocationId = locationId || 'default';
      localStorage.setItem('activeLocationId', this.currentLocationId);
      this.loadFromStorage();
      console.log(`📍 Configuration basculée sur : ${this.currentLocationId}`);
      return true;
    }
    return false;
  }

  getCurrentLocationId() {
    return this.currentLocationId;
  }

  // ============ MÉTHODES DE GESTION DES PROMOTIONS ============

  calculateDiscount(product, quantity = 1) {
    if (!this.config.promotions?.settings?.enablePromotions) {
      return { discount: 0, promotionName: null, type: 'percentage' };
    }

    const now = new Date();
    let bestDiscount = { discount: 0, promotionName: null, type: 'percentage' };

    // Vérifier les Happy Hours
    if (this.config.promotions.happyHours) {
      this.config.promotions.happyHours.forEach(promo => {
        if (promo.isActive && this.isPromotionActive(promo, now) && this.isProductApplicable(product, promo)) {
          if (promo.discount > bestDiscount.discount) {
            bestDiscount = {
              discount: Math.min(promo.discount, this.config.promotions.settings.maxDiscount),
              promotionName: promo.name,
              type: 'happyHour',
              promotionId: promo.id,
              showInAddition: promo.showInAddition !== false
            };
          }
        }
      });
    }

    // Vérifier les promotions par date
    if (this.config.promotions.datePromotions) {
      this.config.promotions.datePromotions.forEach(promo => {
        if (promo.isActive && this.isPromotionActive(promo, now) && this.isProductApplicable(product, promo)) {
          if (promo.discount > bestDiscount.discount) {
            bestDiscount = {
              discount: Math.min(promo.discount, this.config.promotions.settings.maxDiscount),
              promotionName: promo.name,
              type: 'datePromotion',
              promotionId: promo.id,
              showInAddition: promo.showInAddition !== false
            };
          }
        }
      });
    }

    // Vérifier les promotions permanentes
    if (this.config.promotions.permanentPromotions) {
      this.config.promotions.permanentPromotions.forEach(promo => {
        if (promo.isActive && this.isProductApplicable(product, promo)) {
          if (promo.discount > bestDiscount.discount) {
            bestDiscount = {
              discount: Math.min(promo.discount, this.config.promotions.settings.maxDiscount),
              promotionName: promo.name,
              type: 'permanent',
              promotionId: promo.id,
              showInAddition: promo.showInAddition !== false
            };
          }
        }
      });
    }

    return bestDiscount;
  }

  isPromotionActive(promotion, currentTime = new Date()) {
    if (!promotion.isActive) return false;

    const hour = currentTime.getHours();
    const minute = currentTime.getMinutes();
    const day = currentTime.getDay();
    const date = currentTime.toISOString().split('T')[0];

    // Vérifier les jours
    if (promotion.days && promotion.days.length > 0) {
      if (!promotion.days.includes(day)) {
        return false;
      }
    }

    // Vérifier les heures pour les Happy Hours
    if (promotion.startTime && promotion.endTime) {
      const [startHour, startMinute] = promotion.startTime.split(':').map(Number);
      const [endHour, endMinute] = promotion.endTime.split(':').map(Number);

      const currentTimeInMinutes = hour * 60 + minute;
      const startTimeInMinutes = startHour * 60 + startMinute;
      const endTimeInMinutes = endHour * 60 + endMinute;

      if (currentTimeInMinutes < startTimeInMinutes || currentTimeInMinutes > endTimeInMinutes) {
        return false;
      }
    }

    // Vérifier les dates pour les promotions par date
    if (promotion.startDate && promotion.endDate) {
      if (date < promotion.startDate || date > promotion.endDate) {
        return false;
      }
    }

    return true;
  }

  isProductApplicable(product, promotion) {
    const productName = (product.name || '').toLowerCase();
    const productCategory = product.category || '';

    // Vérifier les catégories
    if (promotion.categories && promotion.categories.length > 0) {
      if (!promotion.categories.includes(productCategory)) {
        return false;
      }
    }

    // Vérifier les produits spécifiques
    if (promotion.products && promotion.products.length > 0) {
      const matches = promotion.products.some(promoProduct => {
        const promoProductLower = promoProduct.toLowerCase();
        return productName.includes(promoProductLower) ||
          promoProductLower.includes(productName);
      });

      if (!matches) return false;
    }

    return true;
  }

  // Obtenir toutes les promotions actives
  getActivePromotions() {
    const now = new Date();
    const activePromotions = [];

    if (this.config.promotions?.settings?.showInAddition === false) {
      return activePromotions;
    }

    // Happy Hours
    if (this.config.promotions.happyHours) {
      this.config.promotions.happyHours.forEach(promo => {
        if (promo.isActive && promo.showInAddition !== false && this.isPromotionActive(promo, now)) {
          activePromotions.push({
            ...promo,
            type: 'happyHour',
            activeNow: true
          });
        }
      });
    }

    // Promotions par date
    if (this.config.promotions.datePromotions) {
      this.config.promotions.datePromotions.forEach(promo => {
        if (promo.isActive && promo.showInAddition !== false && this.isPromotionActive(promo, now)) {
          activePromotions.push({
            ...promo,
            type: 'datePromotion',
            activeNow: true
          });
        }
      });
    }

    // Promotions permanentes
    if (this.config.promotions.permanentPromotions) {
      this.config.promotions.permanentPromotions.forEach(promo => {
        if (promo.isActive && promo.showInAddition !== false) {
          activePromotions.push({
            ...promo,
            type: 'permanent',
            activeNow: true
          });
        }
      });
    }

    return activePromotions;
  }

  // Valider un code promo
  validateDiscountCode(code, cartTotal = 0) {
    if (!this.config.promotions?.discountCodes) {
      return { valid: false, message: "Système de codes promo non configuré" };
    }

    const discountCode = this.config.promotions.discountCodes.find(
      dc => dc.code === code && dc.isActive
    );

    if (!discountCode) {
      return { valid: false, message: "Code invalide" };
    }

    const today = new Date().toISOString().split('T')[0];
    if (discountCode.expirationDate && today > discountCode.expirationDate) {
      return { valid: false, message: "Code expiré" };
    }

    if (discountCode.usageLimit && discountCode.usedCount >= discountCode.usageLimit) {
      return { valid: false, message: "Limite d'utilisation atteinte" };
    }

    return {
      valid: true,
      discount: discountCode.discount,
      message: `Code "${discountCode.code}" appliqué`,
      codeInfo: discountCode
    };
  }

  // ============ INTERFACE D'ADMINISTRATION ============

  getAdminInterface() {
    return {
      updateConfig: (section, key, value) => {
        return this.updateConfig(`${section}.${key}`, value);
      },

      addPromotion: (type, promotionData) => {
        if (this.config.promotions && this.config.promotions[type]) {
          const newPromotion = {
            id: `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
            ...promotionData,
            isActive: true,
            showInAddition: promotionData.showInAddition !== false
          };

          this.config.promotions[type].push(newPromotion);
          this.saveToStorage();
          return newPromotion;
        }
        return null;
      },

      updatePromotion: (type, index, promotionData) => {
        if (this.config.promotions && this.config.promotions[type] && this.config.promotions[type][index]) {
          this.config.promotions[type][index] = {
            ...this.config.promotions[type][index],
            ...promotionData
          };
          this.saveToStorage();
          return true;
        }
        return false;
      },

      deletePromotion: (type, index) => {
        if (this.config.promotions && this.config.promotions[type]) {
          if (index >= 0 && index < this.config.promotions[type].length) {
            this.config.promotions[type].splice(index, 1);
            this.saveToStorage();
            return true;
          }
        }
        return false;
      },

      togglePromotion: (type, index) => {
        if (this.config.promotions && this.config.promotions[type] && this.config.promotions[type][index]) {
          this.config.promotions[type][index].isActive = !this.config.promotions[type][index].isActive;
          this.saveToStorage();
          return this.config.promotions[type][index].isActive;
        }
        return false;
      },

      toggleShowInAddition: (type, index) => {
        if (this.config.promotions && this.config.promotions[type] && this.config.promotions[type][index]) {
          this.config.promotions[type][index].showInAddition = !this.config.promotions[type][index].showInAddition;
          this.saveToStorage();
          return this.config.promotions[type][index].showInAddition;
        }
        return false;
      },

      getCurrentConfig: () => {
        return this.getConfig();
      },

      resetToDefaults: () => {
        this.config = this.getDefaultConfig();
        this.saveToStorage();
        return true;
      },

      exportConfig: () => {
        return JSON.stringify(this.config, null, 2);
      },

      importConfig: (jsonConfig) => {
        try {
          const newConfig = JSON.parse(jsonConfig);
          this.config = this.deepMerge(this.getDefaultConfig(), newConfig);
          this.saveToStorage();
          return true;
        } catch (error) {
          console.error("Erreur import config:", error);
          return false;
        }
      }
    };
  }

  // ============ MÉTHODES UTILITAIRES ============

  shouldShowSection(sectionName) {
    if (!this.config.ui?.visibleSections) return true;
    return this.config.ui.visibleSections[sectionName] !== false;
  }

  shouldShowElement(elementName) {
    if (!this.config.ui?.visibleElements) return true;
    return this.config.ui.visibleElements[elementName] !== false;
  }

  getPaymentMethods() {
    return this.config.features?.payment?.methods || ["Espece", "TPE", "T.Resto", "Glovo", "Yassir"];
  }

  isTableSystemEnabled() {
    return this.config.features?.tableSystem?.enabled || false;
  }

  // Nouvelle méthode pour obtenir les paramètres des tables
  getTableConfig() {
    return {
      enabled: this.config.features?.tableSystem?.enabled || false,
      maxTables: this.config.features?.tableSystem?.maxTables || 200,
      allowTransfer: this.config.features?.tableSystem?.allowTableTransfer || false,
      allowLock: this.config.features?.tableSystem?.allowTableLock || false,
      showStatus: this.config.features?.tableSystem?.showTableStatus || false
    };
  }

  // Méthode pour vérifier si le paiement partiel est autorisé
  isPartialPaymentAllowed() {
    return this.config.features?.payment?.allowPartialPayment || false;
  }

  // Méthode pour vérifier si l'addition personnel est activée
  isStaffDiscountEnabled() {
    return this.config.features?.staff?.enabled || false;
  }

  // Méthode pour obtenir le pourcentage de réduction personnel
  getStaffDiscountPercentage() {
    return this.config.features?.staff?.discountPercentage || 20;
  }

  // Méthode pour vérifier si l'annulation est activée
  isCancellationEnabled() {
    return this.config.features?.cancellation?.enabled || false;
  }

  // Méthode pour obtenir les codes admin
  getAdminCodes() {
    return this.config.features?.cancellation?.adminCodes || [];
  }

  // Méthode pour générer un numéro de table automatique
  generateTableNumber() {
    if (!this.isTableSystemEnabled()) {
      return "DIRECT";
    }

    const prefix = "T";
    const maxTables = this.config.features?.tableSystem?.maxTables || 200;
    const randomNum = Math.floor(Math.random() * maxTables) + 1;
    return `${prefix}${randomNum.toString().padStart(3, '0')}`;
  }

  // Alias pour generateTableNumber utilisé dans Menu.js
  generateAutoTableNumber() {
    return this.generateTableNumber();
  }
}

// Créer et exporter une instance unique
const configManager = new ConfigurationManager();
export default configManager;